import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl, NgForm, FormGroupDirective, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { NumberIncrementComponent } from '../number-increment/number-increment.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  standalone: true,
  selector: 'input-material-value',
  templateUrl: './input-material-value.component.html',
  styleUrls: ['./input-material-value.component.css'],
  imports: [CommonModule, ReactiveFormsModule, MatButtonModule, NumberIncrementComponent, MatFormFieldModule, MatIconModule, MatInputModule]
})
export class InputMaterialValueComponent implements OnInit {

  @Input() forceText = false;
  @Input() value = 1;
  @Input() max;
  @Input() min = 1;
  @Input() material;
  @Output() valueChange = new EventEmitter<number>();
  @Output() remove = new EventEmitter();
  @Input() showRemoveOption = false;

  valueFormUnit;

  get unit() {
    return this.material?.reference?.unit;
  }

  constructor() { }

  ngOnInit(): void {
    this.valueFormUnit = new UntypedFormGroup({
      value: new UntypedFormControl(this.value || this.min, [Validators.required]),
    });

    const min = this.min;
    const max = this.max;
    this.valueFormUnit.valueChanges.subscribe(async (value) => {
      const numberValue = parseInt(value.value, 10);

      if (!isNaN(numberValue) && numberValue < min) {
        this.valueFormUnit.controls['value'].setValue(min);
        return;
      }
      if (this.max && !isNaN(numberValue) && numberValue > max) {
        this.valueFormUnit.controls['value'].setValue(max);
        return;
      }
      this.valueChange.emit(value.value);
    })
  }

  doRemove() {
    this.remove.emit();
  }

}
